// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kw-0";